import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MenuAttachmentModel } from '../../../models/menu-attachment.model';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MenuItemCatalogPriceModel } from '../../../models/menu-item-catalog-price.model';
import { MenuTagModel } from '../../../models/menu-tag.model';
import { MAT_DIALOG_DATA, MatChipInputEvent, MatDialog } from '@angular/material';
import { LanguageTranslatePopup } from '../language-translate/language-translate.popup';
import { MenuItemCatalogModel } from '../../../models/menu-item-catalog.model';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import { ItemService } from '../../../../provider/item.service';
import { Subscription } from 'rxjs';
import { CatalogueService } from '../../../../provider/catalogue.service';
import { TranslateModel } from '../../../../core/_base/layout/models/translate.model';
import { TranslationService } from '../../../../provider/translation.service';
import { AWSService } from '../../../../provider/aws.service';
import { AWSS3Image } from '../../../models/AWSS3Image.model';
import { UserService } from '../../../../provider/user.service';
import { CatalogTagModel } from 'src/app/views/models/allergen.model';
import { MenuItemCapacity } from 'src/app/views/models/capacity.model';

@Component({
  selector: 'p-item-catalog',
  templateUrl: './item-catalog.popup.html',
  styleUrls: ['./item-catalog.popup.scss']
})
export class ItemCatalogPopup implements OnDestroy, OnInit {
  tagDatas: MenuTagModel[] = [];
  currentEditCatalogItem: MenuItemCatalogModel;
  currentMenuItemCatalogPriceModel: MenuItemCatalogPriceModel;
  data1: MenuItemCatalogModel = new MenuItemCatalogModel(0, 0, 0, 0, '', '', [], '', '', new Date(), new Date(), 0, '', '', 0);
  subs: Subscription[] = [];

  simpleProducts: string[];
  editableProducts: string[];
  dataSource: any;
  menuItemCapacity: MenuItemCapacity[] = [];



  allergens: CatalogTagModel[] = [
    {
      name: 'Eggs',
      type: 'allergen'
    },
    {
      name: 'Milk',
      type: 'allergen'
    },
    {
      name: 'Coconut',
      type: 'allergen'
    },
    {
      name: 'Nuts',
      type: 'allergen'
    },
    {
      name: 'Cereals Containing Gluten',
      type: 'allergen'
    },
    {
      name: 'Crustaceans',
      type: 'allergen'
    },
    {
      name: 'Fish & Fish Sauces',
      type: 'allergen'
    },
    {
      name: 'Soya Beans',
      type: 'allergen'
    },
    {
      name: 'Celery',
      type: 'allergen'
    },
    {
      name: 'Mustard',
      type: 'allergen'
    },
    {
      name: 'Sesame',
      type: 'allergen'
    },
    {
      name: 'Sulphur Dioxide or Sulphies',
      type: 'allergen'
    },
    {
      name: 'Lupin',
      type: 'allergen'
    },
    {
      name: 'Molluscs',
      type: 'allergen'
    },
    {
      name: 'Peanut',
      type: 'allergen'
    }
  ];

  title = '';

  // Tags Start
  selectable = true;
  removable = true;
  addOnBlur = true;
  separatorKeysCodes = [ENTER, COMMA];

  // Tags End

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: MenuItemCatalogModel,
    public dialog: MatDialog,
    public itemService: ItemService,
    public myService: CatalogueService,
    public tra: TranslationService,
    public awsService: AWSService,
    private userService: UserService
  ) {

    if (isNotNullOrUndefined(data)) {
      // if (data.name == '') {
      //   this.title = 'Add Catalog Item';
      //   this.priceDatas = [new MenuItemCatalogPriceModel()];
      //   this.myService.setPriceDetailDatas([]);
      //   this.tagDatas = [];
      //   this.itemService.setTagDatas([]);
      // } else {
      this.title = 'Edit Catalog Item';
      let sub = this.myService.tag_change$.subscribe(
        (datas: MenuTagModel[]) => {
          this.tagDatas = datas;
        }
      );
      this.subs.push(sub);
      sub = this.myService.priceDetail_change$.subscribe(
        (datas: MenuItemCatalogPriceModel[]) => {
        }
      );
      this.subs.push(sub);
      this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Item Catalog', this.data.id);
      this.myService.getCatalogPrice(data.menu_item_id, data.id);
      this.myService.getCatalogTags(data.id);
      // }
    }
  }

  ngOnInit(): void {
    this.getCapacities();
  }

  ngOnDestroy() {
    for (const item of this.subs) {
      item.unsubscribe();
    }
  }

  addTags(event: MatChipInputEvent): void {
    const input = event.input;
    const value = event.value;
    if ((value || '').trim()) {
      this.tagDatas.push(new MenuTagModel(0, 'menu-item-catalog', this.data.id, value.trim()));
      this.myService.postTagData(new MenuTagModel(0, 'menu-item-catalog', this.data.id, value.trim()));
    }
    if (input) {
      input.value = '';
    }
  }

  addAllergen(index: number) {
    const tag = this.allergens[index];

    const NEWTAG = new MenuTagModel(0, 'menu-item-catalog', this.data.id, JSON.stringify(tag));

    this.tagDatas.push(NEWTAG);
    this.myService.postTagData(NEWTAG);
  }

  removeAllergen(id: number) {
    this.itemService.deleteTagData(id);
    this.tagDatas = this.tagDatas.filter(x => x.id !== id);
  }

  removeTags(i: number) {
    this.itemService.deleteTagData(this.tagDatas[i].id);
    this.tagDatas.splice(i, 1);
  }

  languageTranslate(baseData: any, key: string, val: string, baseDataType?: string) {
    let translateModel: TranslateModel;
    try {
      translateModel = JSON.parse(val);
    } catch (e) {
      translateModel = new TranslateModel();
    }
    if (baseDataType == 'EditCatalogItem') {
      this.currentEditCatalogItem = baseData;
    } else {
      this.currentEditCatalogItem = undefined;
    }

    if (baseDataType == 'MenuItemCatalogPrice') {
      this.currentMenuItemCatalogPriceModel = baseData;
    } else {
      this.currentMenuItemCatalogPriceModel = undefined;
    }

    const dialogRef = this.dialog.open(LanguageTranslatePopup, {
      width: '700px', data: {
        ML: translateModel,
        baseData,
        key,
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.myService.putCatalogData(this.data1);
      if (this.currentEditCatalogItem != undefined) {
        this.myService.putCatalogData(this.currentEditCatalogItem);
      }
      if (this.currentMenuItemCatalogPriceModel != undefined) {
        this.myService.putPriceData(this.currentMenuItemCatalogPriceModel);
      }
    });
  }

  addPrice(isModifier?: boolean) {
    const price = new MenuItemCatalogPriceModel(0, this.data.menu_item_id, this.data.id, 0, '', false, 0, '', '');
    price.is_modifier = Boolean(isModifier);

    this.myService.postPriceData(price).subscribe(
      (resp: MenuItemCatalogPriceModel) => {
        this.myService.getCatalogPrice(this.data.menu_item_id, this.data.id);
      }
    );
  }

  async deletePrice(priceId: number) {
    await this.myService.deleteCatalogPrice(priceId);
    this.myService.getCatalogPrice(this.data.menu_item_id, this.data.id);
  }

  deleteImage(i: number, item: AWSS3Image) {
    const images = this.awsService.catalogImage_change$.getValue();
    images.splice(i, 1);
    this.awsService.deleteImage(this.userService.record_change$.getValue().app_hotel_id, 'Item Catalog', item.file_name).subscribe();
  }

  imgUploadClick() {
    document.getElementById('file1').click();
  }

  async close() {
    await this.dialog.closeAll();
  }

  uploadFile(event: any) {
    let imageName = '';
    let priority;
    if (this.awsService.catalogImage_change$.getValue().length > 0) {
      priority = +this.awsService.catalogImage_change$.getValue()[this.awsService.catalogImage_change$.getValue().length - 1].file_name.split('_')[1].split('.')[0];
      console.log(priority);
    } else {
      priority = 0;
    }
    if (event.target.files && event.target.files.length > 0) {
      for (const file of event.target.files) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          const format = file.type.split('/')[1];
          priority++;
          imageName = this.data.id.toString() + '_' + priority.toString() + '.' + format;
          this.awsService.uploadImage(file, this.userService.record_change$.getValue().app_hotel_id, 'Item Catalog', imageName).subscribe(
            (resp) => {
              console.log(resp);
            }, (err) => {
              console.log(err);
            },
            () => {
              this.awsService.getImages(this.userService.record_change$.getValue().app_hotel_id, 'Item Catalog', this.data.id);
            }
          );
        };
      }
    }
  }

  onCustomItemCreating(args) {
    const newValue = args.text;
    this.editableProducts.unshift(newValue);
    args.customItem = newValue;
  }


  getCapacities() {
    this.itemService.getCapacities(this.data.menu_item_id);
    this.itemService.capacity_change$.subscribe((resp) => {
      this.menuItemCapacity = resp;
    });
  }

  valueChanged(e) {
    this.data.restricted_menu_item_capacities = e.value;
    this.myService.putCatalogData(this.data);
  }

  converToDate(stringDate: string): Date {
    return new Date(stringDate);
  }
}
